<template>
	<div class="proposal-table px-3">
		<b-table-simple responsive bordered class="table-sm">
			<b-thead>
				<b-tr>
					<b-th class="align-middle text-center" v-if="is_editable"></b-th>
					<b-th class="align-middle text-center">No.</b-th>
					<b-th class="align-middle text-center" style="min-width: 150px;">Proposed Repayment Via</b-th>
					<b-th class="align-middle text-center" style="min-width: 200px;">Facility</b-th>
					<b-th class="align-middle text-center" style="min-width: 130px;">Process Amt.</b-th>
					<b-th class="align-middle text-center" style="min-width: 130px;">Charge (%)</b-th>
					<b-th class="align-middle text-center">Charge Amt.</b-th>
					<b-th class="align-middle text-center">Balance Amt.</b-th>
					<b-th class="align-middle text-center" style="min-width: 130px;">Period</b-th>
				</b-tr>
			</b-thead>
			<b-tbody>
				<b-tr v-for="(item, index) in tableData" :key="index">
					<b-td class="align-middle" v-if="is_editable">
						<el-button type="danger" size="mini" @click="deleteHandler(index)" icon="fa fa-times" circle></el-button>
					</b-td>
					<b-td class="align-middle text-center">{{ index + 1 }}</b-td>
					<b-td class="align-middle input-cell">
						<el-select v-model="item.prep_proposed_via" placeholder="Select" size="mini">
							<el-option v-for="optItem in proposedRepaymentOptions" :key="optItem.id"
								:label="optItem.text" :value="optItem.value">
							</el-option>
						</el-select>
					</b-td>
					<b-td class="align-middle input-cell">
						<b-form-input type="text" v-model="item.prep_facility" size="mini"></b-form-input>
					</b-td>
					<b-td class="align-middle input-cell">
						<b-form-input type="text" v-model="item.prep_process_amount" @keydown="_gHlp.checkNonNumericInput"
							size="mini"></b-form-input>
					</b-td>
					<b-td class="align-middle input-cell">
						<b-form-input type="text" v-model="item.prep_charge_rate" @keydown="_gHlp.checkNonNumericInput"
							size="mini"></b-form-input>
					</b-td>
					<b-td class="align-middle input-cell">
						<span v-if="item.prep_id">{{ item.prep_charge_amount | moneyFormatter }}</span>
						<span v-else>{{ (parseFloat(item.prep_process_amount) * parseFloat(item.prep_charge_rate)) / 100 |
							moneyFormatter }}</span>
					</b-td>
					<b-td class="align-middle input-cell">
						<span v-if="item.prep_id">{{ item.prep_balance_amaount | moneyFormatter }}</span>
						<span v-else>{{
							parseFloat(item.prep_process_amount) - ((parseFloat(item.prep_process_amount) *
								parseFloat(item.prep_charge_rate)) / 100)
							| moneyFormatter
						}}
						</span>
					</b-td>
					<b-td class="align-middle input-cell">
						<b-form-input type="text" v-model="item.prep_period" size="mini"></b-form-input>
					</b-td>
				</b-tr>
			</b-tbody>
			<b-tfoot>
				<b-tr class="font-weight-600">
					<b-td :colspan="is_editable ? 3 : 2">
						Summary
					</b-td>
					<b-td></b-td>
					<b-td colspan="2">{{ tableData.reduce((acc, item) => acc + (isNaN(parseFloat(item.prep_process_amount)) ? 0 :
						parseFloat(item.prep_process_amount)), 0) | moneyFormatter }}</b-td>
					<b-td>{{ tableData.reduce((acc, item) => acc + (isNaN(parseFloat(item.prep_charge_amount)) ? 0 :
						parseFloat(item.prep_charge_amount)), 0) | moneyFormatter }}</b-td>
					<b-td colspan="2">{{ tableData.reduce((acc, item) => acc + (isNaN(parseFloat(item.prep_balance_amaount)) ? 0 :
						parseFloat(item.prep_balance_amaount)), 0) | moneyFormatter }}</b-td>
				</b-tr>
			</b-tfoot>
		</b-table-simple>

		<div class="d-flex justify-content-between" v-if="is_editable">
			<el-button size="mini" type="info" icon="fa fa-plus" @click="addProposalRepaymentSource"> Add Repayment</el-button>
			<el-button size="mini" type="primary" icon="fa fa-save" @click="update" :loading="is_loading"> Update</el-button>
		</div>
	</div>
</template>
<script>
import { Select, Option, Button } from 'element-ui'
import { PROPOSED_REPAYMENT_VIAS } from '@/assets/js/status.js'
import initialProposalEventBus from '@/assets/js/EventBus/initialProposalEventBus.js'
import { isEqual, cloneDeep } from 'lodash'
import { mapActions, mapState } from 'pinia'
import { useInvinityStore } from '@/stores/invinityStore'
import { useInitialProposalStore } from '@/stores/initialProposalStore'

export default {
	props: ['psal_id','psal_invinity_id','is_editable'],
	components: {
		[Select.name]: Select,
		[Option.name]: Option,
		[Button.name]: Button,
	},
	data() {
		return {
			tableData: [],
			originalTableData: [],
			proposedRepaymentOptions: [],
			is_updated: false,
			is_loading: false,
		}
	},
	created(){
		this.initComponent()
	},
	watch: {
		psal_id: {
			handler(newVal) {
				if(!_gHlp.isEmpty(newVal)){
					this.getListing(newVal)
				}
			},
			immediate: true,
		}
	},
	methods: {
		...mapActions(useInvinityStore, ['getDropdownList','syncToLms']),
		...mapActions(useInitialProposalStore, ['getRepaymentList','bulkUpSertRepayments']),
		initComponent(){
			this.getDropdownList('lec_proposed_repayment').then(resp => {
				this.proposedRepaymentOptions = resp
			})
		},
		getListing(psal_id){
			this.tableData = []
			this.originalTableData = []
			let params = {
				search:{
					prep_psal_id: psal_id,
				},
				paginate:'no_paginate'
			}
			this.getRepaymentList(params).then(resp => {
				this.tableData = _gHlp.getValue(resp,'data',[]);
				this.originalTableData = cloneDeep(this.tableData);
			}).catch(e => {
				_gNotif.errorFunction(e)
			})
		},
		async update(){
				this.is_loading = true
				if(await this.bulkUpSertRepayments(this.psal_id, this.tableData, this.originalTableData, !_gHlp.isEmpty(this.psal_invinity_id))){
					_gNotif.notifySuccess('<b>Proposed Repayment Sources</b> - Successfully Updated.')
					initialProposalEventBus.$emit('refresh-proposal-detail')
				}
				this.is_loading = false
		},
		addProposalRepaymentSource() {
			this.tableData.push({
				is_new: true,
				prep_proposed_via: '',
				prep_facility: '',
				prep_charge_rate: '',
				prep_process_amount: '',
				prep_period: '',
			})
		},
		deleteHandler(index) {
			this.tableData.splice(index, 1)
		}
	}
}
</script>